import * as React from 'react';

import FilterIcon from '@/assets/icons/FilterIcon';
import NewsArchiveCtx from '@/context/newsArchiveCtx';

import SelectedFilter from './SelectedFilter/SelectedFilter';

const NewsFilterTabs = () => {
    const newsArchiveCtx = React.useContext(NewsArchiveCtx);

    const { showFilterUI, filterVals, clearAllFilters } = newsArchiveCtx;

    return (
        <div className="py-[26px] md:px-10 px-4 border-y border-[#B4B4B4]/35">
            <div className="flex items-center gap-8 flex-wrap">
                <div className="flex items-center gap-0 text-light-gray pr-0 md:pr-8 md:border-r border-light-gray/35">
                    <FilterIcon
                        className="text-light-gray hover:text-black aria-hidden=true cursor-pointer mr-2"
                        style={'gray'}
                        width={12}
                        height={12}
                    />
                    <span className="block uppercase text-inherit font-light text-[14px]">Filters</span>
                </div>

                {showFilterUI ? (
                    <div className="flex items-center gap-8 flex-wrap">
                        <div className="flex items-center gap-0 text-light-gray">
                            <ul className="flex items-center flex-wrap gap-y-6">
                                {showFilterUI
                                    ? filterVals.map((item: any, index: any) => (
                                          <li key={index} className="flex items-center flex-wrap gap-y-6">
                                              {item.length > 0 ? (
                                                  item.map((subItem: any) => (
                                                      <div key={subItem.id} className="mr-[20px]">
                                                          <SelectedFilter value={subItem} />
                                                      </div>
                                                  ))
                                              ) : (
                                                  <div key={item.id} className="mr-[20px]">
                                                      <SelectedFilter value={item} />
                                                  </div>
                                              )}
                                          </li>
                                      ))
                                    : null}
                            </ul>
                        </div>

                        <div className="flex items-center gap-0 text-light-gray pl-0 md:pl-8 md:border-l border-light-gray/35">
                            <div className="flex items-center gap-0">
                                <button
                                    className="block uppercase text-inherit font-light text-[14px] hover:text-black"
                                    onClick={clearAllFilters}
                                >
                                    Clear all
                                </button>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default NewsFilterTabs;
